import styled from '@emotion/styled';
import { fraudAndComplianceColors, mainColors } from 'src/assets/colors';
import {
    ColumnHeaderTemplate,
    SectionMessageTemplate,
    TableCellTemplate,
    TableHeaderRowTemplate,
    TablePropsType,
    TableRowTemplate,
    TableWrapperTemplate,
} from 'src/components/FraudAndCompliance/FraudAndCompliancesTab/FraudAndCompliances/components/CommonTable.styles';

export const MohPopupTriggersTabContainer = styled('div', { label: 'MohPopupTriggersTabContainer' })`
    flex: 1 1 0%;
    height: calc(100vh - 56px);
    overflow-y: auto;
    padding: 24px;
    font-size: 14px;
    line-height: 1.3;
    position: relative;
`;

export const PageHeader = styled('div', { label: 'PageHeader' })`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 16px;
`;

export const SectionHeaderRow = styled('div', { label: 'SectionHeaderRow' })`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 12px;
`;

export const FilterWrapper = styled('div', { label: 'FilterWrapper' })`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const FilterLabel = styled('label', { label: 'FilterLabel' })`
    font-size: 12px;
    color: ${fraudAndComplianceColors.commonTable.txtColor};
`;

export const FilterSelect = styled('select', { label: 'FilterSelect' })`
    min-width: 120px;
    height: 32px;
    padding: 0 8px;
    border: 1px solid ${fraudAndComplianceColors.commonTable.borderColorDefault};
    border-radius: 4px;
    background-color: ${fraudAndComplianceColors.commonTable.bgColor};
    color: ${fraudAndComplianceColors.commonTable.txtColor};
    font-size: 12px;
    cursor: pointer;
`;

export const SortableColumnHeader = styled(ColumnHeaderTemplate, { label: 'SortableColumnHeader' })`
    cursor: pointer;
    user-select: none;
    &:hover {
        background-color: ${fraudAndComplianceColors.commonTable.bgColorMessage};
    }
`;

export const SortableColumnHeaderContent = styled('span', { label: 'SortableColumnHeaderContent' })`
    display: inline-flex;
    align-items: center;
    gap: 4px;
`;

export const SortIcon = styled('span', { label: 'SortIcon' })<{ isActive: boolean }>`
    display: inline-flex;
    flex-shrink: 0;
    color: ${fraudAndComplianceColors.commonTable.txtColor};
    opacity: ${({ isActive }): string => (isActive ? '1' : '0.35')};

    svg {
        width: 12px;
        height: 12px;
    }
`;

export const Header = styled('h1', { label: 'Header' })`
    font-size: 24px;
    margin: 0;
`;

export const ErrorMessage = styled('div', { label: 'ErrorMessage' })`
    font-size: 14px;
    padding: 6px;
    margin-bottom: 16px;
    background-color: ${mainColors.status.ended};
    color: ${mainColors.status.error};
    border-radius: 4px;
`;

export const SectionWrapper = styled('div', { label: 'SectionWrapper' })``;

export const SectionHeader = styled('h2', { label: 'SectionHeader' })`
    font-size: 16px;
    color: ${fraudAndComplianceColors.withdrawalReqColors.txtColor};
    margin: 0;
`;

export const SectionMessage = styled(SectionMessageTemplate, { label: 'SectionMessage' })`
    margin-top: 16px;
`;

export const TableWrapper = styled(TableWrapperTemplate, { label: 'TableWrapper' })``;

export const TableHeaderRow = styled(TableHeaderRowTemplate, { label: 'TableHeaderRow' })``;

export const TableRow = styled(TableRowTemplate, { label: 'TableRow' })<TablePropsType>`
    min-height: 50px;
`;

export const ColumnHeader = styled(ColumnHeaderTemplate, { label: 'ColumnHeader' })``;

export const TableCell = styled(TableCellTemplate, { label: 'TableCell' })`
    padding: 10px 8px;
    width: 16.66%;
`;

